export default __webpack_public_path__ + "static/flag-it-6783c2302478c84fb323ec3d1730c26b.svg";